import classNames from 'classnames';
import React from 'react';
import { useMaxViewport } from '../../core/hooks/use-max-viewport';
import { Typography } from '../typography/typography';
import FrameIconDesktop from './assets/focus-frame-m-xxl.svg?react';
import FrameIconMobile from './assets/focus-frame-xs-s.svg?react';
import styles from './focus-frame.module.scss';

type Props = {
  text: string;
};

export const FocusFrame: React.FC<Props> = ({ text }) => {
  const isTablet = useMaxViewport('s');
  return (
    <div className={styles.root}>
      {isTablet ? (
        <FrameIconMobile className={classNames(styles.frameIcon, styles.shiftToRightSide)} />
      ) : (
        <FrameIconDesktop className={classNames(styles.frameIcon, styles.shiftToRightSide)} />
      )}
      <Typography className={styles.text} color="white" variant="headline-1">
        {text}
      </Typography>
      {isTablet ? (
        <FrameIconMobile className={classNames(styles.frameIcon, styles.rotated, styles.shiftToLeftSide)} />
      ) : (
        <FrameIconDesktop className={classNames(styles.frameIcon, styles.rotated, styles.shiftToLeftSide)} />
      )}
    </div>
  );
};
